import React from 'react';
import { RetailerSettings } from '../../../__generated__/loma';

interface SettingsProviderValue {
  settings: RetailerSettings;
}

interface SettingsProviderProps {
  value: SettingsProviderValue;
}

const SettingsContext = React.createContext<SettingsProviderValue>({
  settings: {},
});

export const SettingsProvider: React.FC<
  React.PropsWithChildren<SettingsProviderProps>
> = ({ children, value: { settings } }) => {
  return (
    <SettingsContext.Provider value={{ settings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = React.useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings was called without a SettingsContext');
  }
  return context.settings;
};
